import React from "react";

export default function QuestionLoadMore({ children }) {
  return <div className="avc-load-more">{children}</div>;
}
